module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "span-10-lg offset-3-lg span-14-md offset-1-md span-14-sm offset-1-sm span-14-xs offset-1-xs",
    class: _vm.popup_border
  }, [_c('div', {
    staticClass: "notification-content"
  }, [_c('div', {
    staticClass: "notification-svg hide-sm"
  }, [_c(_vm.is_correct, {
    tag: "component"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "notification-text"
  }, [_c('div', {
    staticClass: "notification-svg-mobile show-sm notification-svg-sm"
  }, [_c(_vm.is_correct, {
    tag: "component"
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "subheader upcase"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', [_vm._t("default")], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-158ed790"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/molecules/popup_notification.vue
// module id = 596
// module chunks = 1